"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationsApi = void 0;
const core_1 = require("../../core");
const utils_1 = require("./utils");
const LOG_PREFIX = '[Api translations]';
class TranslationsApi {
    constructor({ getDownloadUrl, xhr }) {
        this.xhr = xhr;
        this.getDownloadUrl = (0, utils_1.logNotValidUrlGenerator)(getDownloadUrl);
    }
    get(versionToRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const urlRaw = this.getDownloadUrl(versionToRequest);
                const { data } = yield this.xhr.GET(urlRaw);
                core_1.Log.info(LOG_PREFIX + ' - getting translations');
                return Promise.resolve(data);
            }
            catch (e) {
                core_1.Log.warn(LOG_PREFIX + ' - error getting translations');
                return Promise.reject(e);
            }
        });
    }
}
exports.TranslationsApi = TranslationsApi;
//# sourceMappingURL=translationsApi.js.map